import { dataIntegrationsApiSlice as api } from '../../../apiSlice';
export const addTagTypes = ['Eforsyning'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getEforsyningMetadataIntegrationsEforsyningMetadataGet: build.query<
        GetEforsyningMetadataIntegrationsEforsyningMetadataGetApiResponse,
        GetEforsyningMetadataIntegrationsEforsyningMetadataGetApiArg
      >({
        query: (queryArg) => ({
          url: `/integrations/eforsyning/metadata`,
          params: {
            account_id: queryArg.accountId,
            username: queryArg.username,
          },
        }),
        providesTags: ['Eforsyning'],
      }),
      createEforsyningMetadataRowIntegrationsEforsyningMetadataPost:
        build.mutation<
          CreateEforsyningMetadataRowIntegrationsEforsyningMetadataPostApiResponse,
          CreateEforsyningMetadataRowIntegrationsEforsyningMetadataPostApiArg
        >({
          query: (queryArg) => ({
            url: `/integrations/eforsyning/metadata`,
            method: 'POST',
            body: queryArg.eforsyningMetadataCreate,
          }),
          invalidatesTags: ['Eforsyning'],
        }),
      getEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyGet:
        build.query<
          GetEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyGetApiResponse,
          GetEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyGetApiArg
        >({
          query: (queryArg) => ({
            url: `/integrations/eforsyning/metadata/${queryArg.partitionKey}/${queryArg.rowKey}`,
          }),
          providesTags: ['Eforsyning'],
        }),
      patchEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyPatch:
        build.mutation<
          PatchEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyPatchApiResponse,
          PatchEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyPatchApiArg
        >({
          query: (queryArg) => ({
            url: `/integrations/eforsyning/metadata/${queryArg.partitionKey}/${queryArg.rowKey}`,
            method: 'PATCH',
            body: queryArg.eforsyningMetadataPatch,
          }),
          invalidatesTags: ['Eforsyning'],
        }),
      deleteEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyDelete:
        build.mutation<
          DeleteEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyDeleteApiResponse,
          DeleteEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyDeleteApiArg
        >({
          query: (queryArg) => ({
            url: `/integrations/eforsyning/metadata/${queryArg.partitionKey}/${queryArg.rowKey}`,
            method: 'DELETE',
          }),
          invalidatesTags: ['Eforsyning'],
        }),
      testEforsyningConnectionIntegrationsEforsyningTestPartitionKeyRowKeyGet:
        build.query<
          TestEforsyningConnectionIntegrationsEforsyningTestPartitionKeyRowKeyGetApiResponse,
          TestEforsyningConnectionIntegrationsEforsyningTestPartitionKeyRowKeyGetApiArg
        >({
          query: (queryArg) => ({
            url: `/integrations/eforsyning/test/${queryArg.partitionKey}/${queryArg.rowKey}`,
          }),
          providesTags: ['Eforsyning'],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as dataIntegrationsOpenApi };
export type GetEforsyningMetadataIntegrationsEforsyningMetadataGetApiResponse =
  /** status 200 Successful Response */ EforsyningMetadataEntity[];
export type GetEforsyningMetadataIntegrationsEforsyningMetadataGetApiArg = {
  /** Filter by ReCalc account id (PartitionKey). */
  accountId?: number | null;
  /** Filter by E-forsyning username (RowKey). */
  username?: string | null;
};
export type CreateEforsyningMetadataRowIntegrationsEforsyningMetadataPostApiResponse =
  /** status 201 Successful Response */ EforsyningMetadataEntity;
export type CreateEforsyningMetadataRowIntegrationsEforsyningMetadataPostApiArg =
  {
    eforsyningMetadataCreate: EforsyningMetadataCreate;
  };
export type GetEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyGetApiResponse =
  /** status 200 Successful Response */ EforsyningMetadataEntity;
export type GetEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyGetApiArg =
  {
    /** PartitionKey (ReCalc account id). */
    partitionKey: number;
    /** RowKey (E-forsyning username). */
    rowKey: string;
  };
export type PatchEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyPatchApiResponse =
  /** status 200 Successful Response */ EforsyningMetadataEntity;
export type PatchEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyPatchApiArg =
  {
    /** PartitionKey (ReCalc account id). */
    partitionKey: number;
    /** RowKey (E-forsyning username). */
    rowKey: string;
    eforsyningMetadataPatch: EforsyningMetadataPatch;
  };
export type DeleteEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyDeleteApiResponse =
  unknown;
export type DeleteEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyDeleteApiArg =
  {
    /** PartitionKey (ReCalc account id). */
    partitionKey: number;
    /** RowKey (E-forsyning username). */
    rowKey: string;
  };
export type TestEforsyningConnectionIntegrationsEforsyningTestPartitionKeyRowKeyGetApiResponse =
  /** status 200 Successful Response */ any;
export type TestEforsyningConnectionIntegrationsEforsyningTestPartitionKeyRowKeyGetApiArg =
  {
    /** PartitionKey (ReCalc account id). */
    partitionKey: number;
    /** RowKey (E-forsyning username). */
    rowKey: string;
  };
export type EforsyningMetadataEntity = {
  PartitionKey: string;
  RowKey: string;
  Password?: string | null;
  Active?: boolean | null;
  MeterType?: string | null;
  SupplierId?: string | null;
  ReCalcName?: string | null;
  Address_Backup?: string | null;
  ReCalcAccountId?: number | string | null;
  Integrated?: any | null;
  [key: string]: any;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
  input?: any;
  ctx?: object;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type MeterTypeEnum = 'HeatMeter' | 'WaterMeter';
export type EforsyningMetadataCreate = {
  /** ReCalc account id. */
  PartitionKey: number;
  /** E-forsyning username. */
  RowKey: string;
  /** Plaintext E-forsyning password. */
  Password: string;
  /** If false, the integration skips this account. */
  Active: boolean;
  /** Meter type in eforsyning. */
  MeterType: MeterTypeEnum;
  /** Customer supplier id in E-forsyning. */
  SupplierId: string;
  /** Display name used in ReCalc. */
  ReCalcName: string;
  /** Stable identifier for backup filename. */
  Address_Backup: string;
  /** Customer ReCalc account id. */
  ReCalcAccountId: number;
};
export type EforsyningMetadataPatch = {
  Password?: string | null;
  Active?: boolean | null;
  MeterType?: MeterTypeEnum | null;
  SupplierId?: string | null;
  ReCalcName?: string | null;
  Address_Backup?: string | null;
  ReCalcAccountId?: number | null;
};
export const {
  useGetEforsyningMetadataIntegrationsEforsyningMetadataGetQuery,
  useCreateEforsyningMetadataRowIntegrationsEforsyningMetadataPostMutation,
  useGetEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyGetQuery,
  usePatchEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyPatchMutation,
  useDeleteEforsyningMetadataRowIntegrationsEforsyningMetadataPartitionKeyRowKeyDeleteMutation,
  useTestEforsyningConnectionIntegrationsEforsyningTestPartitionKeyRowKeyGetQuery,
} = injectedRtkApi;
